export const consumptionBetweenTableConfig = [
  { id: 1, title: 'Proteins', valueKey: 'proteins' },
  { id: 2, title: 'Carbs', valueKey: 'carbs' },
  { id: 3, title: 'Fats', valueKey: 'fats' },
  { id: 4, title: 'Sugar', valueKey: 'sugar' },
  { id: 5, title: 'Fiber', valueKey: 'fiber' },
  { id: 6, title: 'Sodium', valueKey: 'sodium' },
] as const;
